export default "__VITE_ASSET__BqXlEF_n__"